enum CardStatus {
	COMPLETE = 'complete',
	ERROR = 'error',
	WARNING = 'warning',
}

export default CardStatus;